// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Grid, Container } from '@mui/material';
import Feed from '../components/Feed';
import SidebarLeft from '../components/SidebarLeft';
import SidebarRight from '../components/SidebarRight';
import RecommendedJobs from '../pages/RecommendedJobs';  // 新创建的推荐职位页面

const HomePage = () => {
    return (
        <div>

            <Container maxWidth="lg" sx={{ marginTop: 4 }}>
                <Grid container spacing={2}>
                    {/* 左侧菜单栏 */}
                    <Grid item xs={12} md={3}>
                        <SidebarLeft />
                    </Grid>

                    {/* 主内容区 */}
                    <Grid item xs={12} md={6}>
                        <Feed />
                    </Grid>

                    {/* 右侧栏 */}
                    <Grid item xs={12} md={3}>
                        <SidebarRight />
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default HomePage;
